<template>
    <div>
        <CRow>
            <CCol xs="12" lg="12">
                <CCard>
                    <CCardHeader>
                        <div class="row">
                            <CCol sm="6" class="align-self-center">
                                <strong>{{ $lang.resume_plan.crud.edit }}</strong>
                            </CCol>
                        </div>
                    </CCardHeader>
                    <CCardBody>
                        <CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade>
                            {{ err_msg }}
                        </CAlert>
                        <CForm @submit.prevent="onAiResumePlanSubmit">
                            <CRow>
                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.resume_plan.form.name }}
                                            <required_span />
                                        </label>
                                        <input type="text" :maxlength="maxlength.name"
                                            :placeholder="$lang.resume_plan.form.name" class="form-control"
                                            v-model="resume_plan.name" />
                                        <small class="error"
                                            v-if="$v.resume_plan.$error && !$v.resume_plan.name.required">{{
                                                $lang.resume_plan.validation.required.name
                                            }}</small>
                                    </div>
                                </CCol>
                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">SKU ID
                                        </label>
                                        <input type="text" :maxlength="maxlength.sku_id"
                                            :placeholder="$lang.resume_plan.form.sku_id" class="form-control"
                                            v-model="resume_plan.sku_id" />
                                    </div>
                                </CCol>
                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.resume_plan.form.platform }}
                                            <required_span />
                                        </label>
                                        <v-select id="platform" :options="platformOptions"
                                            v-model="resume_plan.platform"></v-select>
                                        <small class="error"
                                            v-if="$v.resume_plan.$error && !$v.resume_plan.platform.required">{{
                                                $lang.resume_plan.validation.required.platform
                                            }}</small>
                                    </div>
                                </CCol>

                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.resume_plan.form.type }}
                                            <required_span />
                                        </label>
                                        <v-select id="type" :options="typeOptions"
                                            v-model="resume_plan.type"></v-select>
                                        <small class="error"
                                            v-if="$v.resume_plan.$error && !$v.resume_plan.type.required">{{
                                                $lang.resume_plan.validation.required.type
                                            }}</small>
                                    </div>
                                </CCol>
                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.resume_plan.form.duration }}
                                            <required_span />
                                        </label>
                                        <v-select id="duration" :options="durationOptions"
                                            v-model="resume_plan.duration"></v-select>
                                        <small class="error"
                                            v-if="$v.resume_plan.$error && !$v.resume_plan.duration.required">{{
                                                $lang.resume_plan.validation.required.duration
                                            }}</small>
                                    </div>
                                </CCol>
                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.resume_plan.form.duration_value }}
                                            <required_span />
                                        </label>
                                        <input type="text" :maxlength="maxlength.duration_value"
                                            :placeholder="$lang.resume_plan.form.duration_value" class="form-control"
                                            v-model="resume_plan.duration_value" />
                                        <small class="error"
                                            v-if="$v.resume_plan.$error && !$v.resume_plan.duration_value.required">{{
                                                $lang.resume_plan.validation.required.duration_value
                                            }}</small>
                                        <small class="error"
                                            v-if="$v.resume_plan.$error && !$v.resume_plan.duration_value.minValue">{{
                                                $lang.resume_plan.validation.required.duration_value_min
                                            }}</small>
                                        <small class="error"
                                            v-if="$v.resume_plan.$error && !$v.resume_plan.duration_value.maxValue">{{
                                                $lang.resume_plan.validation.required.duration_value_max
                                            }}{{ maxV }}</small>
                                    </div>
                                </CCol>
                                <CCol md="3">
                                    <div class="form-group">
                                        <label class="form__label">Free AI Resume</label>
                                        <input type="text" :maxlength="maxlength.free_ai_resume_count"
                                            placeholder="Free AI Resume" class="form-control"
                                            v-model="resume_plan.free_ai_resume_count" />
                                    </div>
                                </CCol>

                                <CCol md="3">
                                    <div class="form-group">
                                        <label class="form__label">Resume Count
                                            <required_span />
                                        </label>
                                        <input type="text" :maxlength="maxlength.ai_resume_count"
                                            placeholder="AI Resume count" class="form-control"
                                            v-model="resume_plan.ai_resume_count" />
                                        <small class="error"
                                            v-if="$v.resume_plan.$error && !$v.resume_plan.ai_resume_count.required">{{
                                                $lang.resume_plan.validation.required.ai_resume_count
                                            }}</small>
                                    </div>
                                </CCol>

                                <CCol md="3">
                                    <div class="form-group">
                                        <label class="form__label">Page Count
                                            <required_span />
                                        </label>
                                        <input type="text" :maxlength="maxlength.page_count"
                                            placeholder="Free AI Resume" class="form-control"
                                            v-model="resume_plan.page_count" />
                                        <small class="error"
                                            v-if="$v.resume_plan.$error && !$v.resume_plan.page_count.required">{{
                                                $lang.resume_plan.validation.required.page_count
                                            }}</small>
                                    </div>
                                </CCol>
                                <CCol md="3">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.resume_plan.form.isOnetimeDiscountPlan }}</label>
                                        <br>
                                        <input type="checkbox" :placeholder="$lang.resume_plan.form.isOnetimeDiscountPlan"
                                            :true-value="1" :false-value="0"
                                            v-model="resume_plan.isOnetimeDiscountPlan" />
                                    </div>
                                </CCol>
                                <CCol md="12">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.resume_plan.form.description }}
                                            <required_span />
                                        </label>
                                        <textarea :maxlength="maxlength.description"
                                            :placeholder="$lang.resume_plan.form.description" class="form-control"
                                            v-model="resume_plan.description" rows="5" />
                                        <small class="error"
                                            v-if="$v.resume_plan.$error && !$v.resume_plan.description.required">{{
                                                $lang.resume_plan.validation.required.description
                                            }}</small>
                                    </div>
                                </CCol>
                            </CRow>
                            <span id="plan_pricing">
                                <h4>Plan Price</h4>
                                <div class="inputArea" v-for="input in inputs" :key="input.id">
                                    <CRow>
                                        <CCol md="3">
                                            <div class="form-group">
                                                <label class="form__label">{{ $lang.resume_plan.form.country }}
                                                    <required_span />
                                                </label>
                                                <v-select :id="input.countryId" v-model="input.countryId"
                                                    :options="countryOptions"></v-select>
                                            </div>
                                        </CCol>
                                        <CCol md="3">
                                            <div class="form-group">
                                                <label class="form__label">{{ $lang.resume_plan.form.price }}
                                                    <required_span />
                                                </label>
                                                <input type="text" :id="input.id" v-model="input.price"
                                                    :maxlength="maxlength.price"
                                                    :placeholder="$lang.resume_plan.form.price" class="form-control">
                                            </div>
                                        </CCol>
                                        <CCol md="3">
                                            <div class="form-group">
                                                <label class="form__label">{{ $lang.resume_plan.form.offer_price }}
                                                    <required_span />
                                                </label>
                                                <input type="text" :id="input.id" v-model="input.offer_price"
                                                    :maxlength="maxlength.offer_price"
                                                    :placeholder="$lang.resume_plan.form.offer_price"
                                                    class="form-control">
                                            </div>
                                        </CCol>
                                        <CCol md="1">
                                            <div class="form-group">
                                                <label class="form__label">Has GST?
                                                    <required_span />
                                                </label>
                                                <br>
                                                <input type="checkbox" :placeholder="$lang.resume_plan.form.has_gst"
                                                    :value="0" @change="changedHasGST" v-model="input.has_gst" />
                                            </div>
                                        </CCol>
                                        <CCol md="2">
                                            <div class="form-group">
                                                <label class="form__label">Actions</label><br>
                                                <button type="button" class="btn btn-success" @click="addInput">
                                                    <i class="fa fa-plus"></i>
                                                </button>&nbsp;
                                                <button type="button" class="btn btn-danger"
                                                    @click="subInput(input.id)">
                                                    <i class="fa fa-minus"></i>
                                                </button>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </div>
                            </span>
                            <hr>
                            <span id="plan_pricing">
                                <h4>Rules</h4>
                                <div class="inputArea" v-for="rule in rules" :key="rule.id">
                                    <CRow>
                                        <CCol md="8">
                                            <div class="form-group">
                                                <label class="form__label">Rules
                                                    <required_span />
                                                </label>
                                                <input type="text" placeholder="Rule" class="form-control"
                                                    v-model="rule.rule" />
                                            </div>
                                        </CCol>
                                        <CCol md="2">
                                            <div class="form-group">
                                                <label class="form__label">Actions</label><br>
                                                <button type="button" class="btn btn-success" @click="addRule">
                                                    <i class="fa fa-plus"></i>
                                                </button>&nbsp;
                                                <button type="button" class="btn btn-danger" @click="subRule(rule.id)">
                                                    <i class="fa fa-minus"></i>
                                                </button>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </div>
                            </span>
                            <CRow>
                                <CCol col="6" class="text-left">
                                    <CButton color="primary" :disabled="submitted" class="px-4" type="submit">
                                        {{ $lang.common.general.submit }}
                                    </CButton>
                                </CCol>
                            </CRow>
                        </CForm>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import $ from "jquery";
import Vue from "vue";
import VueForm from "vue-form";
import { ServerTable } from "vue-tables-2";
import { required, requiredIf } from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import { Maxlength } from "../../store/maxlength";
import { Mixin } from "/src/mixins/index.js";
import store from "/src/store/store.js";
import { country, aiResumePlan } from "/src/store/url.js";
import options from "/src/validations/validations.js";

Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);
export default {
    name: "ResumeCreatePlan",
    mixins: [Mixin],
    components: {
        required_span,
    },
    data() {
        return {
            maxV: '',
            counter: 0,
            ruleCounter: 0,
            menuCounter: 0,
            sideMenuCounter: 0,
            messageColor: "",
            submitted: false,
            err_msg: "",
            showAlert: false,
            dismissCountDown: 0,
            self: this,
            moduleCountry: country,
            module: aiResumePlan,
            msg: "",
            typeOptions: [{
                'id': 'Company',
                'label': 'Company',
            },
            {
                'id': 'People',
                'label': 'DirectCandidate',
            },
            ],
            platformOptions: [{
                'id': 0,
                'label': 'Web',
            },
            {
                'id': 1,
                'label': 'Android',
            },
            {
                'id': 2,
                'label': 'IOS',
            },
            ],
            durationOptions: [{
                'id': 'Year',
                'label': 'Yearly',
            },
            {
                'id': 'Month',
                'label': 'Monthly',
            },
            {
                'id': 'Day',
                'label': 'Days',
            },
            ],
            countryOptions: [],
            resume_plan: {
                name: "",
                sku_id: "",
                platform: "",
                type: "",
                duration: "", // duration_unit
                duration_value: "", // duration_value
                free_ai_resume_count: "",
                ai_resume_count: "",
                page_count: "",
                isOnetimeDiscountPlan: 0,
                description: "",
                status: 1,
            },
            inputs: [{
                id: 'country0',
                price: '',
                offer_price: '',
                has_gst: '',
                countryId: '',
            }],
            rules: [{
                id: 'country0',
                rule: '',
            }],
            maxlength: {
                name: Maxlength.resumePlan.name,
                description: Maxlength.resumePlan.description,
                platform: Maxlength.resumePlan.platform,
                price: Maxlength.resumePlan.price,
                offer_price: Maxlength.resumePlan.offer_price,
                duration_value: Maxlength.resumePlan.duration_value,
            },
        };
    },
    validations: {
        resume_plan: {
            type: {
                required,
            },
            name: {
                required,
            },
            description: {
                required,
            },
            platform: {
                required,
            },
            duration: {
                required,
            },
            ai_resume_count: {
                required
            },
            description: {
                required
            },
            page_count: {
                required
            },
            duration_value: {
                required,
                minValue: (function (value) {
                    if (value === '') {
                        return true;
                    }
                    return 1 <= value;
                }),
                maxValue: (function (value) {
                    let self = this;
                    const du = self.resume_plan.duration.id;
                    if (du === "Yearly") {
                        if (value <= 9999) {
                            return true;
                        }
                        self.maxV = 9999;
                        return false;
                    } else if (du === "Monthly") {
                        if (value <= 12) {
                            return true;
                        }
                        self.maxV = 12;
                        return false;
                    } else {
                        if (value <= 365) {
                            return true;
                        }
                        self.maxV = 365;
                        return false;
                    }
                }),
            },

        },
    },
    mounted() {
        let self = this;
        store.commit("showLoader", false); // Loader Off
        self.dismissCountDown = 0;
        this.$root.$on("alert", (arg1, arg2) => { });
        if (localStorage.getItem("showAlert") !== "") {
            this.setAlert(true);
        }
        this.setAlert(false);
        localStorage.setItem("showAlert", "");
        axios.get('/countries/lists').then((response) => {
            response.data.data.map(function (value, key) {
                self.countryOptions.push({ value: value.id, label: value.name });
            });
        });

        const id = this.$route.params.id;
        axios.get(this.viewUrlApi(this.module, id)).then((response) => {
            const plan = response.data.data;

            // Map main plan fields
            this.resume_plan = {
                name: plan.title,
                sku_id: plan.skuCode,
                platform: this.platformOptions.find(p => p.id == plan.platform) || null,
                type: { id: plan.userType, label: plan.userType === "People" ? "DirectCandidate" : "Company" },
                duration: { id: plan.durationUnit, label: plan.durationUnit === "Year" ? "Yearly" : (plan.durationUnit === "Month" ? "Monthly" : "Days") },
                duration_value: plan.durationValue,
                free_ai_resume_count: plan.freeResumeCount,
                ai_resume_count: plan.resumeCount,
                page_count: plan.pageCount,
                isOnetimeDiscountPlan: plan.isOnetimeDiscountPlan ? 1 : 0,
                description: plan.description,
                status: plan.isActive,
            };

            // Map prices
            this.inputs = plan.prices.map((p, idx) => {
                const countryObj = this.countryOptions.find(c => c.value === p.currency_id);
                return {
                    id: `country${idx}`,
                    countryId: countryObj ? countryObj : { value: p.currency_id, label: `ID: ${p.currency_id}` },
                    price: p.price,
                    offer_price: p.offer_price,
                    has_gst: p.has_gst ? 1 : 0,
                };
            });

            // Map rules
            this.rules = plan.rules.map((r, idx) => ({
                id: `rule${idx}`,
                rule: r.title
            }));
        }).catch((error) => {
            console.error("Failed to fetch college alumni list", error);
            this.userOptions = [];
        });
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                if (route.query && route.query.page) {
                    this.activePage = Number(route.query.page);
                }
            },
        },
    },
    methods: {
        changedHasGST(e) {
            let self = this;
            this.v = e.target.checked;
            if (this.v) {
                self.resume_plan.has_gst = 1;
            } else {
                self.resume_plan.has_gst = 0;
            }
        },
        addInput() {
            this.inputs.push({
                id: `country${++this.counter}`,
                price: '',
                offer_price: '',
                has_gst: '',
                countryId: '',
            });
        },
        subInput(id) {
            let self = this;
            const myArr = self.inputs;
            const index = myArr.findIndex(function (o) {
                return o.id === id;
            });
            if (index !== 0) myArr.splice(index, 1);
        },
        addRule() {
            this.rules.push({
                id: `rule${++this.ruleCounter}`,
                rule: '',
            });
        },
        subRule(id) {
            let self = this;
            const myArr = self.rules;
            const index = myArr.findIndex(function (o) {
                return o.id === id;
            });
            if (index !== 0) myArr.splice(index, 1);
        },
        onAiResumePlanSubmit() {
            let self = this;
            this.$v.resume_plan.$touch();
            if (this.$v.resume_plan.$invalid) {
                self.submitted = false; //Enable Button
                this.submitStatus = "ERROR";
            } else {
                let self = this;
                self.submitted = true; //Disable Button
                let postData;
                postData = {
                    "title": self.resume_plan.name,
                    "skuId": self.resume_plan.sku_id,
                    "platform": self.resume_plan.platform,
                    "type": self.resume_plan.type,
                    "durationUnit": self.resume_plan.duration,
                    "durationValue": self.resume_plan.duration_value,
                    "freeAiResumeCount": self.resume_plan.free_ai_resume_count,
                    "aiResumeCount": self.resume_plan.ai_resume_count,
                    "pageCount": self.resume_plan.page_count,
                    "description": self.resume_plan.description,
                    "isOnetimeDiscountPlan": self.resume_plan.isOnetimeDiscountPlan ? 1 : 0,
                    "isActive": self.resume_plan.status,
                    "rules": this.rules.map((r) => r.rule).filter((r) => r !== ""),
                    "priceDetail": this.inputs.map((i) => ({
                        countryId: i.countryId,
                        price: i.price,
                        offer_price: i.offer_price,
                        is_inclusive: 0,
                        gst_id: i.has_gst ? 1 : null,
                        gst_business_name: i.has_gst ? 'The Resourceful Network Private Limited' : null,
                        gst_number: i.has_gst ? '24AAMCT8780H1ZS' : null,
                        has_gst: i.has_gst ? 1 : 0,
                    })),
                }
                const editId = this.$route.params.id;
                axios.post(self.editUrlApi(self.module, editId), postData).then((response) => {
                    self.submitted = false; //Enable Button
                    store.commit("showLoader", false); // Loader Off
                    if (response.data.code == 200) {
                        self.err_msg = response.data.message;
                        localStorage.setItem("notificationType", "success");
                        localStorage.setItem(
                            "notificationMessage",
                            response.data.message
                        );
                        this.$router.push({ name: "Resume Plan" });
                        self.dismissCountDown = 10;
                        self.messageColor = "success";
                    } else {
                        self.err_msg = response.data.message;
                        self.messageColor = "danger";
                        self.dismissCountDown = 10;
                    }
                })
                    .catch(function (error) {
                        let data;
                        if (error.response.data.error) {
                            data = error.response.data.error.toString();
                        } else {
                            data = error.response.data.message;
                        }
                        self.err_msg = data;
                        self.dismissCountDown = 10;
                        self.messageColor = "danger";
                        self.submitted = false; //Enable Button
                    });
            }
        },
        setAlert(value) {
            this.showAlert = value;
        },
    },
};
</script>

<style>
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
</style>
